import React, { Component } from 'react';
import Table from '../../../../../components/_table/Table/Table';
import Panel from '../../../../../components/outline/Panel';
import Button from '../../../../../components/Button';
import { RECOMMEND_STORE_CREATE_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { comparePrePropsAndNextProps, reDirectPage } from '../../../../../lib/common';
import { columns } from './columns';
import './RecommendStoreList.scss';

class RecommendStoreList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { recommendStoreList, initialOption, pagination, getList } = this.props;

    return (
      <Panel className="recommend-store-list">
        <div className="panel-header">
          <div className="title">추천 브랜드 리스트</div>

          <Button
            isRadius
            color="primary"
            text="등록하기"
            onClick={() =>
              reDirectPage({
                path: RECOMMEND_STORE_CREATE_URL_PATH,
              })
            }
          />
        </div>

        <div className="panel-body">
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            initialOption={initialOption}
            pagination={pagination}
            list={recommendStoreList}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    );
  }
}

export default RecommendStoreList;
